// BASED ON https://github.com/google/shaka-player/blob/master/lib/text/ttml_text_parser.js
import shaka from 'shaka-player';
import Logger from '../../utils/logger';

// 00:00:40 or 00:40
const timeColonFormat = /^(?:(\d{2,}):)?(\d{2}):(\d{2})$/;

// 01:02:43.0345555 or 02:43.03
const timeColonFormatMilliseconds = /^(?:(\d{2,}):)?(\d{2}):(\d{2}\.\d{2,})$/;

// 3.45h, 3m or 4.20s
const timeHMSFormat = new RegExp(['^(?:(\\d*(?:\\.\\d*)?)h)?',
  '(?:(\\d*(?:\\.\\d*)?)m)?',
  '(?:(\\d*(?:\\.\\d*)?)s)?',
  '(?:(\\d*(?:\\.\\d*)?)ms)?$'].join(''));

function convertTimeRegexResults(results) {
  // This capture is optional, but will still be in the array as undefined,
  // in which case it is 0.
  const hours = Number(results[1]) || 0;
  const minutes = Number(results[2]) || 0;
  const seconds = Number(results[3]) || 0;
  const milliseconds = Number(results[4]) || 0;

  return (milliseconds / 1000) + seconds + (minutes * 60) + (hours * 3600);
}

// parses time string into number of seconds
export function parseTime(timeStr) {
  if (!timeStr) {
    return null;
  }

  {
    const results = timeColonFormat.exec(timeStr);
    if (results?.[0]) {
      return convertTimeRegexResults(results);
    }
  }

  {
    const results = timeColonFormatMilliseconds.exec(timeStr);
    if (results?.[0]) {
      return convertTimeRegexResults(results);
    }
  }

  {
    const results = timeHMSFormat.exec(timeStr);
    if (results?.[0]) {
      return convertTimeRegexResults(results);
    }
  }

  return null;
}

function extractText(el) {
  if (el.nodeName === 'br') {
    return '\n';
  }

  if (el.nodeType === Node.TEXT_NODE) {
    return el.textContent;
  }

  if (!el.childNodes.length) {
    return el.textContent;
  }

  return Array.from(el.childNodes).map(extractText).join('');
}

function extractTTMLCues(data, timeContext) {
  const str = shaka.util.StringUtils.fromUTF8(data);

  if (!str) {
    return [];
  }

  const parser = new DOMParser();

  let xml;
  try {
    xml = parser.parseFromString(str, 'text/xml');
  } catch (e) {
    Logger.warn('Failed to parse ttml subtitles', e);
    return [];
  }

  return Array.from(xml.querySelectorAll('[begin]'))
    .map((el) => {
      let begin = parseTime(el.getAttribute('begin'));
      let end = parseTime(el.getAttribute('end'));
      const duration = parseTime(el.getAttribute('dur'));

      if (begin === null || (!end && !duration)) {
        return null;
      }

      end = end || begin + duration;

      begin += timeContext.periodStart;
      end += timeContext.periodStart;

      return new shaka.text.Cue(begin, end, extractText(el));
    })
    .filter(cue => !!cue);
}

// https://shaka-player-demo.appspot.com/docs/api/shaka.extern.TextParser.html
export default class Mp4TtmlParser {
  parseInit() { }

  parseMedia(data, timeContext) {
    const payload = [];

    const parser = new shaka.util.Mp4Parser()
      .box('mdat', shaka.util.Mp4Parser.allData((mdat) => {
        // Join this to any previous payload, in case the mp4 has multiple mdats.
        payload.push(...extractTTMLCues(mdat, timeContext));
      }));

    parser.parse(data, false);

    return payload;
  }
}
